// import Vue from 'vue';
import App from './App.vue';

// tap指令 解决三星浏览器click与touch事件冲突问题
import vueTap from 'vue-js-tap';
Vue.use(vueTap);

//vant组件引入
import Button from 'vant/lib/button';
import Cell from 'vant/lib/cell';
import CellGroup from 'vant/lib/cell-group';
import Popup from 'vant/lib/popup';
import NavBar from 'vant/lib/nav-bar';
import RadioGroup from 'vant/lib/radio-group';
import Radio from 'vant/lib/radio';
import CouponCell from 'vant/lib/coupon-cell';
import Field from 'vant/lib/field';
import Card from 'vant/lib/card';
import List from 'vant/lib/list';
import Dialog from 'vant/lib/dialog';
import Picker from 'vant/lib/picker';
import Tab from 'vant/lib/tab';
import CheckboxGroup from 'vant/lib/checkbox-group';
import Toast from 'vant/lib/toast';
import Search from 'vant/lib/search';
import CheckBox from 'vant/lib/checkbox';
import Tabs from 'vant/lib/tabs';
import TimePiker from 'vant/lib/datetime-picker';
import SwitchCell from 'vant/lib/switch-cell';
import Switch from 'vant/lib/switch';
import Uploader from 'vant/lib/uploader';
import Actionsheet from 'vant/lib/actionsheet';
import Loading from 'vant/lib/loading';
import Swipe from 'vant/lib/swipe';
import SwipeItem from 'vant/lib/swipe-item';
import Notify from 'vant/lib/notify';
import ImagePreview from 'vant/lib/image-preview';
import { Icon } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { Row, Col } from 'vant';


// vant组件样式文件
import 'vant/lib/button/style';
import 'vant/lib/cell/style';
import 'vant/lib/cell-group/style';
import 'vant/lib/popup/style';
import 'vant/lib/nav-bar/style';
import 'vant/lib/radio-group/style';
import 'vant/lib/radio/style';
import 'vant/lib/coupon-cell/style';
import 'vant/lib/field/style';
import 'vant/lib/card/style';
import 'vant/lib/list/style';
import 'vant/lib/dialog/style';
import 'vant/lib/picker/style';
import 'vant/lib/tab/style';
import 'vant/lib/checkbox-group/style';
import 'vant/lib/toast/style';
import 'vant/lib/search/style';
import 'vant/lib/checkbox/style';
import 'vant/lib/tabs/style';
import 'vant/lib/datetime-picker/style';
import 'vant/lib/switch-cell/style';
import 'vant/lib/switch/style';
import 'vant/lib/uploader/style';
import 'vant/lib/actionsheet/style';
import 'vant/lib/loading/style';
import 'vant/lib/swipe/style';
import 'vant/lib/swipe-item/style';
import 'vant/lib/notify/style';

// console.log(Dialog)

import 'vant/lib/index.css';
import axios from 'axios';
import pub from './../common/public';
import store from './store';
import MetaInfo from 'vue-meta-info';
import Filter from './../common/js/filter';
import VueLazyLoad from 'vue-lazyload';
import router from './router';

Vue.use(VueLazyLoad, {
  loading: '//static.house730.com/m/images/house-bg.png',
  error: '//static.house730.com/m/images/house-bg.png'
})
  .use(MetaInfo)
  .use(Filter)
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Popup)
  .use(NavBar)
  .use(Radio)
  .use(RadioGroup)
  .use(CouponCell)
  .use(Field)
  .use(Card)
  .use(List)
  .use(Dialog)
  .use(Picker)
  .use(Tab)
  .use(Toast)
  .use(CheckboxGroup)
  .use(Search)
  .use(CheckBox)
  .use(Tabs)
  .use(TimePiker)
  .use(SwitchCell)
  .use(Switch)
  .use(Uploader)
  .use(Actionsheet)
  .use(Loading)
  .use(Swipe)
  .use(SwipeItem)
  .use(Icon)
  .use(ImagePreview)
  .use(Notify)
// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    config.params = config.params || {};
    config.params.cityen = 'hk';
    config.params.platform = config.params.platform || 'wap';
    config.params.language = pub.getLang();
    config.params.token = window.token || pub.getCookie('cEVaUDFrZ1kd0RA');
    if (config.method == 'get') {
      config.params.timeStamp = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params.timeStamp
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
// 添加token失效拦截器
axios.interceptors.response.use(
  function (response) {
    if (response.data.code === 100) {
      pub.delCookie('cEVaUDFrZ1kd0RA');
      pub.delCookie('ERnJaMWtkM');
      if (location.href.indexOf("my/login") == -1) router.replace({
        path: '/login',
        query: {
          referrer: router.currentRoute.fullPath
        } // 到登录页重新获取token
      });
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

window.errorImg = function (img, type) {
  if (type === 'agent') {
    img.src = '/staff-default.png';
  } else if (type === 'user') {
    img.src = '/user-default.png';
  } else if (type === 'agent-company') {
    img.src = '/agent-bg.png';
  } else {
    img.src = '/house-bg.png';
  }
  // 防止onerror事件死循环,同一个标签加载10次后置空
  let count = img.getAttribute('count');
  count = count ? ++count : 1;
  img.setAttribute('count', count);
  count > 10 ? (img.onerror = null) : '';
};

Vue.prototype.axios = axios;
Vue.prototype.store = store;
Vue.prototype.pub = pub;
Vue.config.productionTip = false;
Vue.use(Collapse).use(CollapseItem);
Vue.use(Row).use(Col);

// Vue.prototype.$bus = new Vue()
// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// Vue.use(vConsole);

// Vue.use(Vant);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');